<template>
  <div class="flex flex-col items-center justify-center min-h-screen">
    <div class="w-full max-w-md px-10 py-8 bg-gray-type-5">
      <img
        src="@/assets/img/password-changed.svg"
        class="block mx-auto mt-10 text-center"
        alt="Password changed"
      />
      <h2 class="mt-8 text-2xl font-bold text-center text-dark-type-3">Booking successful</h2>
      <div
        class="mt-1 text-sm font-medium text-center text-dark-type-4"
      >Keep an eye out for email notifications. We will keep you updated on the movement of your shuttle.</div>
      <router-link
        :to="{ name: 'dashboard.my-bookings' }"
        class="block w-56 h-12 py-4 mx-auto mt-12 font-bold text-center text-white bg-active rounded"
      >View ticket</router-link>
    </div>
    <div class="w-full max-w-md px-10 py-8 bg-gray-type-5" v-if="localBookingData">
      <div class="details-wrapper">
        <booking-summary
            :route-details="localBookingData.firstTripData">
        </booking-summary>
        <booking-summary
            v-if="localBookingData.returnTripData"
            :return-trip="true"
            :route-details="localBookingData.returnTripData">
        </booking-summary>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import BookingSummary from "@/components/BookingSummary";
export default {
  components: {BookingSummary},
  props: ["bookingId"],
  computed: {
    ...mapGetters("app", ["bookings"]),
    ...mapGetters("app", ['localBookingData']),
    booking() {
      if (!this.bookingId) {
        return;
      }

      return this.bookings.find(booking => booking.id === this.bookingId);
    }
  }, beforeDestroy() {
    this.$store.dispatch('app/updateLocalBookingData', null);
  }
};
</script>

<style lang="scss" scoped>
.details-wrapper {
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.08);
  border-radius: 0.5rem;
}
</style>